const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
  // カスタムプロパティの値を更新
  document.documentElement.style.setProperty('--scrollbar', `(50vw - ${scrollbarWidth}px)`)
};

window.addEventListener('load', setScrollbarWidth);
window.addEventListener('resize', setScrollbarWidth);
